/* unplugin-vue-components disabled */import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import { apiGlobalGetRepairOrderLog } from '@/api/global';
import SearchForm from './searchForm.vue';
import dayjs from 'dayjs';
export default /*#__PURE__*/_defineComponent({
  __name: 'repairLog',
  props: {
    gid: {
      type: Number,
      default: 0
    }
  },
  setup(__props) {
    const props = __props;
    const filter = ref({
      gid: props.gid,
      date: [dayjs().subtract(7, 'days').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
    });
    const columns = [{
      label: 'ID',
      prop: 'id'
    }, {
      label: '渠道',
      prop: 'cname'
    }, {
      label: 'UltraSDKID',
      prop: 'uid'
    }, {
      label: '角色账号ID',
      prop: 'suid'
    }, {
      label: '区服名称',
      prop: 'serverName'
    }, {
      label: '游戏角色ID',
      prop: 'roleId'
    }, {
      label: '角色名称',
      prop: 'roleName'
    }, {
      label: '设备号',
      prop: 'deviceId'
    }, {
      label: '下单时间',
      prop: 'createTime'
    }, {
      label: '支付方式',
      prop: 'payTypeName'
    }, {
      label: 'Ultra订单号',
      prop: 'hgOrderNo'
    }, {
      label: '第三方订单号',
      prop: 'thirdOrderNo'
    }, {
      label: '成交金额',
      prop: 'dealAmount'
    }, {
      label: '币种',
      prop: 'currency'
    }, {
      label: '道具名称',
      prop: 'goodsName'
    }, {
      label: '操作人',
      prop: 'user'
    }, {
      label: '操作时间',
      prop: 'supplementTime'
    }];
    const getTableData = () => {
      const params = JSON.parse(JSON.stringify(filter.value));
      params.startTime = params.date && params.date[0] || '';
      params.endTime = params.date && params.date[1] || '';
      delete params.date;
      tableLoading.value = true;
      apiGlobalGetRepairOrderLog(params).then(res => {
        if (res.code === 0) {
          tableData.value = res.data;
          total.value = res.total;
        }
      }).finally(() => {
        tableLoading.value = false;
      });
    };
    const handleSearch = data => {
      filter.value = data;
      getTableData();
    };
    const {
      tableData,
      tableLoading,
      current,
      pageSize,
      total,
      handleSizeChange,
      handleCurrentChange
    } = UseTable(getTableData);
    onMounted(() => {
      getTableData();
    });
    return (_ctx, _cache) => {
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      return _openBlock(), _createBlock(_component_u_card_pane, {
        name: "globalRepairLog"
      }, {
        default: _withCtx(() => [_createVNode(SearchForm, {
          gid: _unref(filter).gid,
          onSearch: handleSearch
        }, null, 8, ["gid"]), _createVNode(UTable, {
          options: columns,
          data: _unref(tableData),
          loading: _unref(tableLoading),
          pagination: "",
          "current-page": _unref(current),
          "page-size": _unref(pageSize),
          total: _unref(total),
          onSizeChange: _unref(handleSizeChange),
          onCurrentChange: _unref(handleCurrentChange)
        }, null, 8, ["data", "loading", "current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])]),
        _: 1
      });
    };
  }
});